import React from 'react'
import { IconButton, Typography, Box } from '@mui/material'
import { IconEdit, IconReportSearch } from '../../../../../assets/images/icons'
import { getImageUrl, sortingDataEntityWise } from '../../../../../util'
import { LEGEND_COLOR_MAP_V2 } from '../../../../../constants'
import { MuiImage } from '../../../../../components'
import { IconClose } from '../../../../../assets/images/iconsV2'

import {
  GraphContentWrapper,
  GraphContent,
  ContentText,
  GraphRow,
  SliderWrap,
  GraphRowDetails,
  BrandImageryRowInsightsWrapper,
  BrandImageryRowInsights,
  BrandImageryRowInsightsHeading,
  InsightsRteContWrap,
  IconButtonWrapper
} from './style'
import LhsHeading from '../LhsHeading/LhsHeading'
import BrandImageryRowL2 from '../BrandImageryRowL2/BrandImageryRowL2'
import { InsightsRteContent } from '../../../../../components'

const BrandImageryRow = ({
  row,
  index,
  onChange,
  canMove = false,
  editTitleFlag,
  editTitleClicked,
  showLevel2Func,
  showExpandAllCTA,
}) => {
  const imageryChangeHandler = (value, imagery) => {
    if (!canMove) return
    const newData = row?.data?.map((item) => {
      if (item.logoName === imagery.logoName) {
        return {
          ...item,
          scale: value,
        }
      }
      return item
    })
    onChange({
      ...row,
      data: newData,
    })
  }

  return (
    <GraphContentWrapper className={`${row?.showLevel2 ? 'showRowLevel2' : ''}`}>
      <GraphContent
        className={`brandImageryRowAppendices brandImageryRow tRow ${row?.nestedData?.length > 0 || row?.insights?.length > 0 ? 'brandImageryLevel2' : 'brandImageryLevel2'}`}
      >
        <ContentText className={`contentText showEdit_${editTitleFlag}`}>
          <LhsHeading showExpandAllCTA={showExpandAllCTA} row={row} />

          {editTitleFlag && (
            <IconButton
              aria-label='Edit'
              onClick={() => editTitleClicked(row)}
              sx={{ height: '35px', margin: '23px 0 0 5px' }}
            >
              <IconEdit />
            </IconButton>
          )}

          {(row?.nestedData?.length > 0 || row?.insights?.length > 0) && (
            <IconButton size='small' onClick={() => showLevel2Func(row, index)} className={`btnExpand ${row?.showLevel2 ? 'arrowBtn' : ''}`}>
              <IconReportSearch />
            </IconButton>
          )}
        </ContentText>
        <GraphRow className='list'>
          {row?.data?.map((rowItem, index) => {
            if (rowItem.scale === 10) return false
            let percent = ((rowItem.scale + 3) / 6) * 100

            let bgColor = LEGEND_COLOR_MAP_V2.Negative
            if (percent > 33 && percent < 66) {
              bgColor = LEGEND_COLOR_MAP_V2.Mixed
            }
            if (percent >= 66) {
              bgColor = LEGEND_COLOR_MAP_V2.Positive
            }

            let sliderWrapStyle = {}
            if (percent > 50) {
              const img = new Image()
              img.src = getImageUrl('logos', rowItem?.logoImg, 'png')
              const maxHeight = 15
              const aspectRatio = img.width / img.height
              const adjustedWidth = maxHeight * aspectRatio
              sliderWrapStyle = { marginLeft: `-${adjustedWidth + 17}px` }

              setTimeout(() => {
                const img = new Image()
                img.src = getImageUrl('logos', rowItem?.logoImg, 'png')
                const maxHeight = 15
                const aspectRatio = img.width / img.height
                const adjustedWidth = maxHeight * aspectRatio
                sliderWrapStyle = { marginLeft: `-${adjustedWidth + 17}px` }
              }, 1000)
            }

            return (
              <SliderWrap
                dataEntityType={rowItem.entityType}
                key={index}
                color={bgColor}
                percent={percent}
                disabled={!canMove}
                logoname={rowItem.logoName}
                logo={getImageUrl('logos', rowItem?.logoImg, 'png')}
              >
                {sliderWrapStyle && <>
                  <span className='sliderValue' data-percent={percent}></span>
                  <MuiImage
                    src={getImageUrl('logos', rowItem?.logoImg, 'png')}
                    style={{ marginLeft: sliderWrapStyle.marginLeft || 0 }}
                  />
                </>}
              </SliderWrap>
            )
          })}
        </GraphRow>
      </GraphContent>
      {row?.nestedData && (
        <BrandImageryRowInsightsWrapper
          className='brandImageryRow details 11111111111'
          style={{ display: row?.showLevel2 ? 'block' : 'none' }}
        >
          <BrandImageryRowInsights className='brandImageryRowAppendices' style={{ paddingBottom: '10px' }}>
            {showExpandAllCTA && (
              <Typography className={`hideP ${showExpandAllCTA ? 'pptSubHeading' : ''}`}>
                {row.title}
              </Typography>
            )}
            <BrandImageryRowInsightsHeading>
              {row.title}
              <IconButtonWrapper
                variant='outlined'
                color='light'
                startIcon={<IconClose />}
                onClick={() => showLevel2Func(row, index)}
              />
            </BrandImageryRowInsightsHeading>


            {row?.insights && (
              <InsightsRteContWrap>
                <InsightsRteContent content={row?.insights} />
              </InsightsRteContWrap>
            )}
          </BrandImageryRowInsights>
          {row?.nestedData?.map((rowDataL2, index) => (
            <BrandImageryRowL2
              canMove={canMove}
              key={index}
              row={rowDataL2}
              parentHeading={row.title}
            />
          ))}
        </BrandImageryRowInsightsWrapper>
      )}
    </GraphContentWrapper>
  )
}

export default BrandImageryRow
